import { Flex } from "@chakra-ui/react";
import React, { ReactNode } from "react";

type Props = {
  children?: ReactNode;
};

const FilterWrapper: React.FC<Props> = ({ children }) => (
  <Flex alignItems="center" w="full" minH="80px">
    {children}
  </Flex>
);

export { FilterWrapper };
